import { combineReducers } from 'redux';
import authReducer from '@/redux/slice/auth.slice';
import placementOfficerReducer from '@/redux/slice/placementOfficer.slice';
import studentReducer from '@/redux/slice/student.slice';
import humanResourceReducer from '@/redux/slice/humanResource.slice';

const rootReducer = combineReducers({
  auth: authReducer,
  po: placementOfficerReducer,
  hr: humanResourceReducer,
  student: studentReducer,
});

export default rootReducer;
